import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import {
  addWebsiteUser as addWebsiteUserConnect,
  removeWebsiteUser as removeWebsiteUserConnect,
} from '../../../actions/website';
import { getUserGroupOptions } from '../../../constants/user';
import API from '../../../libs/api';
import { selectBusiness } from '../../../selectors/business';
import { selectUser } from '../../../selectors/user';
import { selectWebsite, selectWebsiteUsers } from '../../../selectors/website';
import { InlineFieldContainer, FormContainer } from '../../common';
import WebsiteUsersForm from '../../core/WebsiteUsersForm';

export default function UserManagementPage() {
  const dispatch = useDispatch();

  const website = useSelector(selectWebsite);
  const websiteUsers = useSelector(selectWebsiteUsers);
  const user = useSelector(selectUser);
  const business = useSelector(selectBusiness);

  async function onRemoveUser(websiteUser) {
    await API.removeUserFromWebsite(website.id, websiteUser.id);

    const userIndex = websiteUsers.findIndex((currentWebsiteUser) => {
      return currentWebsiteUser.id === websiteUser.id;
    });

    if (userIndex > -1) {
      dispatch(removeWebsiteUserConnect({ index: userIndex }));
    }
  }

  async function onAddUser(firstName, lastName, email, role) {
    const payload = {
      firstName,
      lastName,
      email,
      role,
    };

    const { data: websiteUser } = await API.addUserToWebsite(website.id, payload);

    const currentUser = websiteUsers.find((currentWebsiteUser) => {
      return currentWebsiteUser.id === websiteUser.id;
    });

    if (!currentUser) {
      dispatch(addWebsiteUserConnect({ value: websiteUser, index: websiteUsers.length }));
    }
  }

  const roleOptions = getUserGroupOptions(user);

  return (
    <FormContainer loadedKeyPath={['business', 'core']}>
      <InlineFieldContainer title={<h2>Users</h2>} enableDelete={false}>
        <WebsiteUsersForm
          user={user}
          business={business}
          websiteUsers={websiteUsers}
          onAddUser={onAddUser}
          onRemoveUser={onRemoveUser}
          roleOptions={roleOptions}
        />
      </InlineFieldContainer>
    </FormContainer>
  );
}
